import { BaseUniDriver } from '@wix/wix-ui-test-utils/unidriver';
import { InputUniDriver } from '../Input/Input.uni.driver';
import { CalendarUniDriver } from '../Calendar/Calendar.uni.driver';

export interface DatePickerUniDriver extends BaseUniDriver {
  driver: {
    exists: () => Promise<boolean>;
    open: () => ReturnType<InputUniDriver['focus']>;
    getWidth: () => Promise<string>;
    clickOutside: () => Promise<void>;
    getFooter: () => Promise<HTMLElement | null>;
  };
  inputDriver: InputUniDriver;
  calendarDriver: CalendarUniDriver;
}
